jQuery(function ($) {
    if (typeof promo_gclid != "undefined") {
        $('#wrapper-navbar').prepend(`<div id="sld_gclid" class="p-1">${promo_gclid.bandeau}</div>`)
    }
})